
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parent-guide",
      function () {
        return require("private-next-pages/parent-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parent-guide"])
      });
    }
  